import { DEV_URL } from "./requests";

const BASE_URL = `${DEV_URL}/api/UserPreferences/Filters`;

const getHeaders = (userToken) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${userToken}`,
});

/**
 * Load all saved filters for a specific page.
 * @param {object} params
 * @param {string} params.pageKey - e.g. "PricingContent", "CustomPricingContent", "RankingsPricingContent"
 * @param {string} params.userToken - JWT access token
 * @returns {Promise<object>} - { success, data: [{ rowKey, name, filters, createdAt }] }
 */
export const loadUserFiltersApi = async (params) => {
  const { pageKey, userToken } = params;
  // if (!userToken) {
  //   throw new Error("Missing user token for load filters request");
  // }

  const response = await fetch(
    `${BASE_URL}/list?pageKey=${encodeURIComponent(pageKey)}`,
    {
      method: "GET",
      headers: getHeaders(userToken),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load saved filters");
  }

  const result = await response.json();

  // Parse filters from JSON string for each entry
  if (result.success && Array.isArray(result.data)) {
    result.data = result.data.map((item) => ({
      ...item,
      filters: typeof item.filters === "string" ? JSON.parse(item.filters) : item.filters,
    }));
  }

  return result;
};

/**
 * Save a named filter for a specific page.
 * @param {object} params
 * @param {string} params.pageKey
 * @param {string} params.name - user-provided filter name
 * @param {object} params.filters - serialized filter values
 * @param {string} params.userToken - JWT access token
 * @returns {Promise<object>} - { success, message }
 */
export const saveUserFiltersApi = async (params) => {
  const { pageKey, name, filters, userToken } = params;
  // if (!userToken) {
  //   throw new Error("Missing user token for save filters request");
  // }

  const response = await fetch(`${BASE_URL}/Add`, {
    method: "POST",
    headers: getHeaders(userToken),
    body: JSON.stringify({ PageKey: pageKey, Name: name, Filters: typeof filters === "string" ? filters : JSON.stringify(filters) }),
  });

  if (!response.ok) {
    throw new Error("Failed to save filter");
  }

  return await response.json();
};

/**
 * Delete a saved filter by its ID.
 * @param {object} params
 * @param {string} params.filterId - RowKey of the saved filter
 * @param {string} params.pageKey - Page key (e.g. "Pricing")
 * @param {string} params.userToken - JWT access token
 * @returns {Promise<object>} - { success, message }
 */
export const deleteUserFilterApi = async (params) => {
  const { filterId, pageKey, userToken } = params;
  // if (!userToken) {
  //   throw new Error("Missing user token for delete filter request");
  // }

  const response = await fetch(`${DEV_URL}/api/UserPreferences/delete/${encodeURIComponent(filterId)}/${encodeURIComponent(pageKey)}`, {
    method: "DELETE",
    headers: getHeaders(userToken),
  });

  if (!response.ok) {
    throw new Error("Failed to delete filter");
  }

  return await response.json();
};
